import React, {Component} from 'react';
import {FormattedMessage, injectIntl} from 'react-intl';
import connect from 'react-redux/es/connect/connect';
import {Card, Col, Layout, Row} from 'antd';
import '../HomeScreen.css';
import moment from 'moment';
import {APPOINTMENT_TYPE_URL_NAME, DRIVE_IN_RECEPTION, FASTLANE_RECEPTION, isNextDisabled, MAINTENANCE, STEP_SERVICE_MOBILITY, STEPS_JOURNEY, TIRE_REPLACEMENT, TIRES, TIRES_EXCHANGE, WAIT_MOBILITY,} from './definition/business';
import {getSizeClass, isBigEnough} from './helper/uiHelper';
import StepsFragment from './fragments/StepsFragment';
import {CommentFragment} from './fragments/CommentFragment';
import RecapFragment from './fragments/RecapFragment';
import uuidV4 from 'uuid/v4';
import {Spinner} from '../components/UIToolbox';
import AppointmentStepScreenFragment from './fragments/AppointmentStepScreenFragment';
import {SpinnerModal} from '../components/SpinnerModal';
import {Redirect} from 'react-router-dom';
import SAButton from '../../components/common/button/SAButton';
import {fetchDealers} from "../../actions/dealersActions";
import Storage from "../../services/Storage";
import BrandUtil from "../../services/BrandUtil";

const {Content} = Layout;

class JourneyScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // journey
      plateNumber: null,
      leasingCompany: null,
      previewVisible: false,
      previewImage: null,
      fileList: [],
      workspaceReservations: false,
      selectedDate: null,
      selectedSlot: null,
      reception: null,
      unbookableDays: [],
      bookableDays: [],
      // address
      number: null,
      street: null,
      zipCode: null,
      city: null,
      country: null,
      // official document
      sending: false,
      comment: null,
    };
    this._calendarRef = React.createRef();
    this.onCommentChange = this.onCommentChange.bind(this);
    this.onSelectDate = this.onSelectDate.bind(this);
    this.onSelectSlot = this.onSelectSlot.bind(this);
    this.onReceptionChange = this.onReceptionChange.bind(this);
    this.onToggleWorkspaceReservations = this.onToggleWorkspaceReservations.bind(this);
    // address
    this.onNumberChange = this.onNumberChange.bind(this);
    this.onStreetChange = this.onStreetChange.bind(this);
    this.onZipCodeChange = this.onZipCodeChange.bind(this);
    this.onCityChange = this.onCityChange.bind(this);
    this.onCountryChange = this.onCountryChange.bind(this);

    this.goBack = this.goBack.bind(this);
  }

  componentDidMount() {
    const {selectedDealer, customerPreJourneyInfo} = this.props;
    if (!selectedDealer) {
      return;
    }
    this.props.switchSteps({ steps: STEPS_JOURNEY });
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions.bind(this));
    if (customerPreJourneyInfo.profile) {
      if (customerPreJourneyInfo.profile.address) {
        const {number, city, country, street, zipCode} = customerPreJourneyInfo.profile.address;
        this.setState({number, city, country, street, zipCode});
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions.bind(this));
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.userDataLoading && !this.props.userDataLoading) {
      this.setState({ sending: true });
    }
    if (this.props.userDataLoading && !this.props.appointment && nextProps.appointment) {
      this.setState({ sending: false });
      this.props.history.goBack();
    }
  }

  hasOption = (options, optionId) => !!options.find(o => o.id === optionId);

  updateWindowDimensions() {
    // This strange code allow to switch between desktop and mobile display.
    // I think it is mainly to make non-responsive Antd component responsive.
    // For example the <Steps> component which in recent version of antd has a 'responsive' attribute
    this.setState({
      width: window.innerWidth,
      height: window.innerHeight,
      sizeClass: getSizeClass(window.innerWidth),
    });
  };

  onCommentChange = e => {
    this.setState({ comment: e.target.value });
  };

  onToggleWorkspaceReservations = () => {
    this.setState({ workspaceReservations: !this.state.workspaceReservations });
  };

  onSelectDate = selectedDate => {
    this.setState({
      selectedDate: moment(selectedDate).format('YYYY-MM-DD'),
      selectedSlot: null,
    });
  };

  onSelectSlot = selectedSlot => {
    this.setState({ selectedSlot });
  };

  onReceptionChange = reception => {
    this.setState({ reception });
  };

  setAvailabilities = availabilities => {
    this.setState({ availabilities });
  };

  // address
  onNumberChange = e => {
    this.setState({ number: e.target.value });
  };

  onStreetChange = e => {
    this.setState({ street: e.target.value });
  };

  onZipCodeChange = e => {
    this.setState({ zipCode: e.target.value });
  };

  onCityChange = e => {
    this.setState({ city: e.target.value });
  };

  onCountryChange = e => {
    this.setState({ country: e.target.value });
  };

  // Journey flow
  goBack = () => {
    this.props.history.goBack();
  };

  goToPreviousStep = () => {
    const {stepper} = this.props
    this.props.gotoPreviousStep();
    if (stepper.previousStep === STEP_SERVICE_MOBILITY) {
      this.setState({
        selectedDate: null,
        selectedSlot: null,
        reception: null,
        unbookableDays: [],
        bookableDays: [],
        // address
        number: null,
        street: null,
        zipCode: null,
        city: null,
        country: null
      });
    }
  };

  goToNextStep = () => {
    this.props.gotoNextStep();
  };

  // send journey
  finishJourney = () => {
    const {number, street, zipCode, city, country, reception, selectedSlot, selectedDate, comment} = this.state;
    const {customerPreJourneyInfo, createAppointmentRequest, publicContext} = this.props;
    const {tiresExchange, tireReplacement, selectedOptions=[], chosenMobility, generalInformation} = createAppointmentRequest;

    const services = selectedOptions.map(s => s.id);
    const mobility = chosenMobility && chosenMobility.mobilityOption;
    const workspaceReservations = chosenMobility && chosenMobility.workspaceReservations;
    const dealerId = this.props.selectedDealer.id;
    const vin = this.props.selectedVIN ? this.props.selectedVIN.vin : this.props.selectedVehicle.vin;
    const apptServices = { services };

    if (customerPreJourneyInfo.type === TIRES || (selectedOptions.findIndex(o => o.id === TIRES_EXCHANGE) >= 0 && tiresExchange.type && tiresExchange.mode)) {
      apptServices.tiresExchange = tiresExchange
    }

    if (this.hasOption(selectedOptions,TIRE_REPLACEMENT)) {
      const {selectedTiresBrands, selectedFrontLeftTire, selectedFrontRightTire, selectedBackLeftTire, selectedBackRightTire, tireWidth, tireProfile, tireDiameter, selectedTireType} = tireReplacement;
      apptServices.tiresReplacement = {
        brands: selectedTiresBrands,
        positions: {
          frontLeft: selectedFrontLeftTire,
          frontRight: selectedFrontRightTire,
          rearLeft: selectedBackLeftTire,
          rearRight: selectedBackRightTire,
        },
        tireSize: {
          width: tireWidth,
          profile: tireProfile,
          diameter: tireDiameter,
        },
        tireType: selectedTireType,
      };
    }

    const body = {
      services: apptServices,
    };

    if (publicContext.bookingToken){
      body.services.bookingToken = publicContext.bookingToken;
    }

    if (customerPreJourneyInfo.type === MAINTENANCE || (customerPreJourneyInfo.type === TIRES && this.hasOption(selectedOptions, TIRES_EXCHANGE))) {
      body.mobility = {
        mobility,
        workspaceRequest: mobility === WAIT_MOBILITY && workspaceReservations,
      };
    } else {
      body.mobility = {};
    }

    body.mobility.customerAddress = {
      number,
      street,
      zipCode,
      city,
      country,
    };

    if (generalInformation.phoneNumber) {
      body.phone = generalInformation.phoneNumber;
    }
    if (!isNaN(Number(generalInformation.mileage))) {
      body.mileage = Number(generalInformation.mileage);
    }
    // Licence plate is mandatory
    body.licensePlate = generalInformation.plateNumber;
    body.leasingCompany = generalInformation.leasingCompany;
    body.model = generalInformation.vinVehicleModel || this.props.selectedVehicle.model;

    body.uuid = uuidV4();
    body.reception = {
      dropOff: {
        driveIn: reception === DRIVE_IN_RECEPTION,
        duringWorkingHours: true,
        fastLane: reception === FASTLANE_RECEPTION,
        date: selectedDate,
        time: selectedSlot.startTime,
      },
    };
    let finaleType = customerPreJourneyInfo.type;
    if(finaleType === TIRES && this.hasOption(selectedOptions, TIRES_EXCHANGE)){
      finaleType = MAINTENANCE;
    }

    const payload = { type: finaleType, dealerId, vin, body };
    const requestBody = {
      dealerId,
      vin,
      type: APPOINTMENT_TYPE_URL_NAME[finaleType],
      body: payload,
      callback: this.goBack,
    };
    if (comment && comment.length > 0) {
      const fd = new FormData();
      fd.append('comment', comment);
      fd.append('uuid', body.uuid);
      requestBody.comment = fd;
    }
    this.props.dispatchSaveCustomerAppointment(requestBody);
  };

  renderButton = (disabled, onclick, label, primary) => {
    return (<SAButton
      type={primary ? 'primary' : 'secondary'}
      onClick={onclick}
      disabled={disabled}
    >
      <FormattedMessage id={label} style={{color: 'white'}}/>
    </SAButton>)
  };

  renderStepFooter = () => {
    const {stepper} = this.props;
    return (<Row>
      <Content style={{}}>
        <Row type="flex" gutter={16}>
          <Col
            span={8}
            xs={24}
            sm={24}
            md={8}
            lg={24}
            xl={24}
            xxl={8}
            style={{marginBottom: 10}}
          >
            {this.renderButton(false, this.goBack, 'customer.journey.nav.cancel')}
          </Col>
          {!stepper.isFirst && (
            <Col
              span={8}
              xs={24}
              sm={24}
              md={8}
              lg={24}
              xl={24}
              xxl={8}
              style={{marginBottom: 10}}
            >
              {this.renderButton(
                stepper.isFirst,
                this.goToPreviousStep,
                'customer.journey.nav.previous'
              )}
            </Col>
          )}
          <Col
            span={8}
            xs={24}
            sm={24}
            md={8}
            lg={24}
            xl={24}
            xxl={8}
            style={{marginBottom: 10}}
          >
            {!stepper.isLast &&
            this.renderButton(
              isNextDisabled(
                stepper.currentStep,
                this.state,
                this.props.selectedVIN,
                this.props.customerPreJourneyInfo,
                this.props.createAppointmentRequest,
                this.props.publicContext,
              ),
              this.goToNextStep,
              'customer.journey.nav.next',
              true
            )}
            {stepper.isLast  &&
            this.renderButton(
              false,
              this.finishJourney,
              'customer.journey.nav.finish',
              true
            )}
          </Col>
        </Row>
      </Content>
    </Row>)
  };

  render() {
    const {intl: {formatMessage}, frontendConfig} = this.props;
    const brand = BrandUtil.resolveBrand().toLowerCase();
    const language = Storage.getItem('lg') || "en";
    const {sizeClass, selectedDate, selectedSlot, reception, sending, availabilities, number, street, zipCode, city, country, comment} = this.state;
    const host = window.location.host.split('.').pop().toLowerCase();
    const {selectedVehicle, selectedVIN, selectedDealer, appointmentLoading} = this.props;

    if (!selectedDealer) {
      return <Redirect to="/public/home" />;
    }

    const isBig = isBigEnough(sizeClass);
    return (
      <Layout
        className="layout"
        style={{ backgroundColor: 'rgb(242,242,242)', paddingBottom: 40 }}
      >
        <SpinnerModal visible={appointmentLoading} />
        {sending && (
          <Content style={{ margin: 'auto', paddingTop: '100px', width: '90%' }}>
            <Spinner />
          </Content>
        )}
        {!sending && (
          <Content style={{ margin: 'auto', paddingTop: '100px', width: '90%' }}>
            <Row
              style={{
                padding: 30,
                backgroundColor: 'white',
                marginBottom: 20,
              }}
            >
              <Col
                span={5}
                xs={24}
                sm={24}
                md={24}
                lg={5}
                xl={5}
                xxl={5}
                style={{ marginRight: isBig ? 25 : 0 }}
              />
              <StepsFragment sizeClass={sizeClass}
              />
              <Col
                span={5}
                xs={24}
                sm={24}
                md={24}
                lg={5}
                xl={5}
                xxl={5}
                style={{ marginLeft: isBig ? 25 : 0 }}
              />
            </Row>
            <Row gutter={16}>
              <Col
                className={isBig ? 'sticky' : null}
                xs={24}
                sm={24}
                md={24}
                lg={6}
                xl={6}
                xxl={6}
              >
                <RecapFragment
                  dealer={selectedDealer.dealerName}
                  vehicle={
                    selectedVIN
                      ? selectedVIN.brand
                      : `${selectedVehicle.brand} ${selectedVehicle.model}`
                  }
                  date={selectedDate}
                  slot={selectedSlot}
                  reception={reception}
                  sizeClass={sizeClass}
                />
              </Col>
              <Col span={12} xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                <Row style={{ marginBottom: 50 }}>
                  <AppointmentStepScreenFragment
                    selectedVehicle={selectedVehicle}
                    selectedVIN={selectedVIN}
                    selectedDate={selectedDate}
                    selectedSlot={selectedSlot}
                    reception={reception}
                    sizeClass={sizeClass}
                    availabilities={availabilities}
                    number={number}
                    street={street}
                    zipCode={zipCode}
                    city={city}
                    country={country}
                    methods={this}
                  />
                </Row>
              </Col>
              <Col className="sticky" xs={24} sm={24} md={24} lg={6} xl={6} xxl={6}>
                <CommentFragment
                  formatMessage={formatMessage}
                  sizeClass={sizeClass}
                  onChange={this.onCommentChange}
                  comment={comment}
                  title={'customer.journey.comment.title'}
                />
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={6} xs={24} sm={24} md={24} lg={6} xl={6} xxl={6} />
              <Col span={12} xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                <Card>
                  <Row>{this.renderStepFooter()}</Row>
                </Card>
              </Col>
              <Col span={6} xs={24} sm={24} md={24} lg={6} xl={6} xxl={6} />
            </Row>
          </Content>
        )}
        {frontendConfig.environment && frontendConfig.environment === "PRODUCTION" &&
          <footer style={{paddingLeft: '16px', paddingRight: '16px'}} className="customer-main" tabIndex="-1">
            <Row type="flex" justify="end" align="middle">
              <Col>
                <a style={{color: "black"}} href={frontendConfig[`dsa-${brand}-${host}`][language]}
                   target="_blank">DSA</a>
              </Col>
            </Row>
          </footer>
        }
      </Layout>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  dispatchFetchDealers: () => dispatch(fetchDealers()),
  dispatchSaveCustomerAppointment: params => dispatch({type: 'SAVE.CUSTOMER_APPOINTMENT.REQUEST', params}),
  dispatchFetchVehicle: () => dispatch({ type: 'FETCH.CUSTOMER_VEHICLE.REQUEST' }),
  openChangeCarModal: () => dispatch({ type: 'CHANGE_CAR_MODAL', changeCarModal: true }),
  openChangeDealerModal: () => dispatch({type: 'SHOW.CHANGE_DEALER_MODAL', changeDealerModal: true}),
  gotoNextStep: () => dispatch({type: 'SAVE.SET_NEXT_STEP.REQUEST'}),
  gotoPreviousStep: () => dispatch({ type: 'SAVE.SET_PREVIOUS_STEP.REQUEST' }),
  switchSteps: (params) => dispatch({ type: 'SAVE.SET_STEPS.REQUEST',  params}),
});

const mapStateToProps = state => ({
  selectedVehicle: state.customerVehicle.selectedVehicle,
  selectedVIN: state.customerVehicle.selectedVIN,
  selectedDealer: state.customerDealer.selectedDealer,
  customerPreJourneyInfo: state.customerPreJourneyInfo.preJourneyInfo,
  appointmentLoading: state.customerAppointment.loading,
  appointmentError: state.customerAppointment.error,
  appointment: state.customerAppointment.appointment,
  stepper: state.stepper,
  createAppointmentRequest: state.createAppointmentRequest,
  publicContext: state.publicContext,
  frontendConfig: state.frontendConfig
});

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(JourneyScreen)
);
